export default "__VITE_ASSET__C7BrDI$Q__"